import { render, staticRenderFns } from "./SmPlanIcon.vue?vue&type=template&id=2f5f7014&scoped=true&"
var script = {}
import style0 from "./SmPlanIcon.vue?vue&type=style&index=0&id=2f5f7014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f7014",
  null
  
)

export default component.exports